import React, { useEffect, useState } from 'react';
import { api } from '../api/client';
import {
  PageHeader, Card, Badge, EmptyState, formatDate,
} from '../components/UI';

export default function Subscriptions() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // all | active | expired

  useEffect(() => { refresh(); }, []);

  async function refresh() {
    setLoading(true);
    try { setList(await api.subscriptions.list()); }
    catch (e) { alert(e.message); }
    finally { setLoading(false); }
  }

  const filtered = list.filter(s => {
    if (filter === 'active')  return s.status === 'active' && s.days_left >= 0;
    if (filter === 'expired') return s.days_left < 0;
    return true;
  });

  const totalRevenue = list
    .filter(s => s.amount)
    .reduce((sum, s) => sum + parseFloat(s.amount), 0);

  return (
    <>
      <PageHeader
        eyebrow="Pagos"
        title="Suscripciones"
        subtitle={`${list.length} registros · $${totalRevenue.toLocaleString('es-AR')} en total`}
      />

      {/* Filters */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 20 }}>
        <FilterPill active={filter === 'all'}     onClick={() => setFilter('all')}>Todas</FilterPill>
        <FilterPill active={filter === 'active'}  onClick={() => setFilter('active')}>Activas</FilterPill>
        <FilterPill active={filter === 'expired'} onClick={() => setFilter('expired')}>Vencidas</FilterPill>
      </div>

      {loading ? (
        <EmptyState>Cargando…</EmptyState>
      ) : filtered.length === 0 ? (
        <EmptyState>Sin registros para este filtro.</EmptyState>
      ) : (
        <Card padding={0}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--border)' }}>
                <Th>Paciente</Th>
                <Th>Período</Th>
                <Th>Monto</Th>
                <Th>Método</Th>
                <Th>Referencia</Th>
                <Th>Estado</Th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(s => (
                <tr key={s.id} style={{ borderBottom: '1px solid var(--border)' }}>
                  <Td>
                    <div style={{ fontWeight: 400 }}>{s.patient_name}</div>
                    <div style={{ fontSize: 11, color: 'var(--ink-soft)' }}>{s.patient_email}</div>
                  </Td>
                  <Td muted>
                    {formatDate(s.start_date)} → {formatDate(s.end_date)}
                  </Td>
                  <Td>{s.amount ? `$${parseFloat(s.amount).toLocaleString('es-AR')}` : '—'}</Td>
                  <Td muted>{s.payment_method}</Td>
                  <Td muted>{s.payment_ref || '—'}</Td>
                  <Td>
                    {s.days_left < 0 ? (
                      <Badge tone="danger">Vencida</Badge>
                    ) : s.days_left <= 7 ? (
                      <Badge tone="warning">Vence en {s.days_left}d</Badge>
                    ) : (
                      <Badge tone="success">Activa</Badge>
                    )}
                  </Td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </>
  );
}

const Th = ({ children }) => (
  <th style={{
    textAlign: 'left', padding: '12px 16px',
    fontSize: 9, fontWeight: 300, letterSpacing: '0.18em',
    textTransform: 'uppercase', color: 'var(--earth)',
  }}>{children}</th>
);

const Td = ({ children, muted }) => (
  <td style={{
    padding: '12px 16px', fontSize: 13,
    color: muted ? 'var(--ink-soft)' : 'inherit',
  }}>{children}</td>
);

function FilterPill({ active, children, onClick }) {
  return (
    <button onClick={onClick} style={{
      padding: '5px 14px',
      borderRadius: 20,
      border: '1px solid ' + (active ? 'var(--ink)' : 'var(--border)'),
      background: active ? 'var(--ink)' : 'transparent',
      color: active ? 'var(--sand)' : 'var(--ink-soft)',
      fontSize: 11, fontWeight: 300, letterSpacing: '0.1em',
      cursor: 'pointer',
    }}>{children}</button>
  );
}
